import { motion } from "framer-motion";
import { Instagram, ArrowUpRight } from "lucide-react";
import { SITE } from "../data/site";
import { FadeIn } from "./Reveal";

export const Footer = () => {
  return (
    <footer id="prenota" data-testid="footer" className="relative bg-[var(--bg-2)] border-t border-[var(--line)]">
      {/* Big CTA */}
      <a
        data-testid="footer-reserve"
        href={SITE.reserveUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="group block px-5 md:px-10 pt-24 md:pt-40 pb-10"
      >
        <div className="mx-auto max-w-[1600px]">
          <div className="flex items-start justify-between gap-4">
            <FadeIn>
              <span className="font-mono text-[11px] tracking-[0.3em] uppercase text-[var(--fg-dim)]">
                — Prenota ora
              </span>
            </FadeIn>
            <ArrowUpRight
              size={40}
              strokeWidth={1}
              className="text-[var(--fg-dim)] transition-transform duration-500 group-hover:translate-x-2 group-hover:-translate-y-2 group-hover:text-[var(--fg)]"
            />
          </div>
          <motion.h2
            className="font-serif leading-[0.8] tracking-tighter text-[22vw] md:text-[19vw] transition-colors duration-500 text-[var(--fg)] group-hover:text-[var(--fg-dim)]"
          >
            Prenota
          </motion.h2>
          <p className="mt-4 max-w-md text-[var(--fg-dim)] text-sm md:text-base">
            Le prenotazioni sono gestite tramite Resmio. Clicca ovunque su questo
            blocco per scegliere data, ora e numero di ospiti.
          </p>
        </div>
      </a>

      {/* Info grid */}
      <div className="mx-auto max-w-[1600px] px-5 md:px-10 pb-14">
        <div className="grid md:grid-cols-4 gap-10 md:gap-8 py-12 md:py-16 border-t border-[var(--line)]">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3">
              <img src="/assets/mark-white.png" alt="Dal Conte" className="h-10 w-auto" />
              <div className="leading-none">
                <p className="font-serif text-2xl tracking-wide">DAL CONTE</p>
                <p className="font-mono text-[9px] tracking-[0.35em] uppercase text-[var(--fg-dim)] mt-1">
                  Pizzeria di Campagna
                </p>
              </div>
            </div>
          </div>

          <div>
            <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-[var(--fg-dim)]">
              Orari
            </span>
            <p className="mt-3 text-sm">{SITE.hoursDays}</p>
            <p className="mt-1 font-mono text-sm text-[var(--fg-dim)]">{SITE.hoursTime}</p>
            <p className="mt-1 font-mono text-[11px] text-[var(--fg-dim)]">{SITE.closedShort}</p>
          </div>

          <div>
            <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-[var(--fg-dim)]">
              Contatti
            </span>
            <p className="mt-3 text-sm leading-relaxed">{SITE.address}</p>
            <a href={SITE.phoneHref} className="mt-2 block font-mono text-sm link-underline w-fit">
              {SITE.phoneDisplay}
            </a>
            <a
              data-testid="footer-email"
              href={SITE.emailHref}
              className="mt-2 block font-mono text-sm link-underline w-fit break-all"
            >
              {SITE.email}
            </a>
            <a
              data-testid="footer-instagram"
              href={SITE.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.2em] uppercase link-underline"
            >
              <Instagram size={15} strokeWidth={1.4} /> Instagram
            </a>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-8 border-t border-[var(--line)] font-mono text-[10px] tracking-[0.2em] uppercase text-[var(--fg-dim)]">
          <span>© {new Date().getFullYear()} Dal Conte — Villachiara (BS)</span>
          <span data-testid="footer-opening">Apertura · {SITE.openingDate}</span>
        </div>
      </div>
    </footer>
  );
};
